import { render, staticRenderFns } from "./HabeasData.vue?vue&type=template&id=3d87011e&scoped=true&"
import script from "./HabeasData.vue?vue&type=script&lang=js&"
export * from "./HabeasData.vue?vue&type=script&lang=js&"
import style0 from "./HabeasData.vue?vue&type=style&index=0&id=3d87011e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d87011e",
  null
  
)

export default component.exports